<template>
  <div class="lp-list-item" @click="handleListItemClick">
    <div class="item_wrapper" :style="wrapperStyles">
      <slot name="title" :row="item"></slot>
      <div
        class="item_row text_ellipsis_1"
        :style="rowStyles"
        v-for="(row, index) in rows"
        :key="row.prop + index"
        @click="row.click && row.click(item)"
      >
        <template
          v-if="
            row.show ? row.show(deepDotAccessObj(item, row.prop), item) : true
          "
        >
          <span class="row_label">{{ row.label }}:</span>
          <slot v-if="row.slot" :name="row.slot" :row="item"></slot>
          <el-tag
            class="text_ellipsis_1"
            v-else-if="!!row.click"
            :type="row.type ? row.type(item) : ''"
            size="small"
            >{{
              row.format
                ? row.format(deepDotAccessObj(item, row.prop), item)
                : deepDotAccessObj(item, row.prop)
            }}</el-tag
          >
          <span v-else class="row_text text_ellipsis_1">
            {{
              row.format
                ? row.format(deepDotAccessObj(item, row.prop), item)
                : deepDotAccessObj(item, row.prop)
            }}
          </span>
        </template>
      </div>

      <!-- 功能插槽 -->
      <div class="item_options flex">
        <slot name="option" :row="item"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { deepDotAccessObj } from "@/utils/utils";

export default {
  name: "LpListItem",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    /**
     * 数据行
     * {
     * 	label - 标签文本
     * 	prop - 数据源键名
     * }
     */
    rows: {
      type: Array,
      default: () => [],
    },
    wrapperStyles: {
      type: Object,
      default: () => {},
    },
    rowStyles: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    handleListItemClick() {
      this.$emit("click", this.item);
    },
    deepDotAccessObj,
  },
};
</script>

<style lang="scss" scoped>
.flex {
  display: flex;
}

.text_ellipsis_1 {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.lp-list-item {
  padding: 5px;
  margin-bottom: 5px;

  .item_wrapper {
    position: relative;
    overflow: hidden;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 8px 0;
    padding: 9px 15px;

    .item_row {
      display: flex !important;
      align-items: center;
      max-width: 100%;
      font-size: 15px;
      margin: 3px 0;

      .row_label {
        font-weight: bold;
        margin-right: 5px;
        white-space: nowrap;
      }
    }

    .item_options {
      margin-top: 10px;
      //   justify-content: flex-end;
      flex-wrap: wrap;
      align-items: center;
    }

    .item_order {
      position: absolute;
      top: 9%;
      right: 15px;
      width: 25px;
      height: 25px;
      font-weight: bold;
      border-radius: 50%;
      border: 1px solid #4d4d4d;
      color: #4d4d4d;
    }
  }
}
</style>
